export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11874.7dc7b55f.jpg";